import { getIsMobile } from '../store/basic-params/basic-params-selectors';
import { wixP } from '../services/wix-params-utils';

// takes wix param or wix param path and state (determines is mobile from state) or boolean
export const getWixP = (wixParam, stateOrBool) =>
  wixP(wixParam, typeof stateOrBool === 'object' ? getIsMobile(stateOrBool) : stateOrBool);
